import { rem } from '../common/constants.ts';

/**
 * Builds the breakpoint data array.
 *
 * sm/md are manually anchored to match Tailwind's defaults.
 * lg → 6xl step up by STEP_PX (256px) from md.
 *
 * Result when BASE_FONT_SIZE_PX is 13:
 *   sm:  640px  /  49.23076923076923rem
 *   md:  768px  /  59.07692307692308rem
 *   lg:  1024px /  78.76923076923077rem
 *   xl:  1280px /  98.46153846153845rem
 *   2xl: 1536px /  118.15384615384616rem
 *   3xl: 1792px /  137.84615384615384rem
 *   4xl: 2048px /  157.53846153846155rem
 *   5xl: 2304px /  177.23076923076923rem
 *   6xl: 2560px /  196.92307692307693rem
 */
const buildBreakpointData = (): { name: string; px: number }[] => {
  const STEP_PX = 256;
  const extendedNames = ['lg', 'xl', '2xl', '3xl', '4xl', '5xl', '6xl'] as const;

  const base = [
    { name: 'sm', px: 640 },
    { name: 'md', px: 768 },
  ];

  let current = 768;
  const extended = extendedNames.map((name) => {
    current += STEP_PX;

    return { name, px: current };
  });

  return [...base, ...extended];
};

/**
 * Generates a Tailwind `screens` object from breakpoint data.
 * Values are expressed in rem so they respect the user's browser font-size
 * preference rather than being locked to px.
 */
export const screens: Record<string, string> = Object.fromEntries(
  buildBreakpointData().map(({ name, px }) => {
    return [name, rem(px)];
  })
);
